import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { AtaturkQuotes } from "@/components/AtaturkQuotes";
import { Timeline } from "@/components/Timeline";
import { NewsSection } from "@/components/NewsSection";
import { FunFacts } from "@/components/FunFacts";
import { HowToCelebrate } from "@/components/HowToCelebrate";
import { Quiz } from "@/components/Quiz";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <AtaturkQuotes />
        <NewsSection />
        <Timeline />
        <FunFacts />
        <HowToCelebrate />
        <Quiz />
      </main>
      <Footer />
    </div>
  );
}
